const TAG_ADDRESS = "category";

module.exports = {
  TAG_ADDRESS
};
